export const Path = {
    SIMULATION_INSTANCE_FORMFIELDS: ['formFields'],
    SIMULATION_INSTANCE_INITIALVALUES: ['initialValues']
};
